import React ,{Component} from 'react'
import './Signup.css';
import Card1 from './Card1'

class Signup extends Component{

render(){return(
  <div>
         <Card1 />
  </div>
)}}
export default Signup